/* import __COLOCATED_TEMPLATE__ from './content-owner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();